<template>
    <div class="row">
        <div class="col-md-6 text-center">
            <img :src="profileImage" class="img-fluid img-thumbnail rounded-circle img-profile" />
            <hr>
            <h3>Verificaties</h3>
            <div class="row">
                <div class="col-md-4 text-center pr-5 pl-5 pt-5" v-if="profile.identificationDocumentId != null">
                    <h2 title="Legitimatie">ID</h2>
                </div>
                <div class="col-md-4 text-center pr-5 pl-5 pt-5" v-if="profile.kvkDocumentId != null">
                    <h2 title="Kamer van Koophandel">KVK</h2>
                </div>
                <div class="col-md-4 text-center pr-5 pl-5 pt-5" v-if="profile.vogDocumentId != null">
                    <h2 title="Verklaring Omtrent Goed Gedrag">VOG</h2>
                </div>
                <div class="col-md-4 text-center pr-5 pl-5 pt-5" v-if="profile.employerDocumentId != null">
                    <h2 title="Werkgeversverklaring">WV</h2>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-horizontal" v-if="!!user">
                <div class="form-group row">
                    <label for="name" class="col-form-label col-md-4">Naam:</label>
                    <div class="col-md-8">
                        <input class="form-control-plaintext" id="name" name="name" disabled placeholder="Naam" v-model="fullName" /> 
                    </div>
                </div>
                <div class="form-group row">
                    <label for="email" class="col-form-label col-md-4">Email:</label>
                    <div class="col-md-8">
                        <input class="form-control-plaintext" id="email" name="email" disabled placeholder="Email" v-model="user.email" /> 
                    </div>
                </div>
                <div class="form-group row">
                    <label for="phone" class="col-form-label col-md-4">Telefoonnummer:</label>
                    <div class="col-md-8">
                        <input class="form-control-plaintext" id="phone" name="phone" disabled placeholder="Telefoonnummer" v-model="user.phoneNumber" /> 
                    </div>
                </div>
                <div class="form-group row">
                    <label for="phone" class="col-form-label col-md-4">Vergunning:</label>
                    <div class="col-md-8">
                        <input class="form-control-plaintext" id="permit" name="permit" disabled placeholder="Geen vergunning (ND-nr)" v-model="profile.permitNumber" /> 
                    </div>
                </div>
                <div class="form-group">
                    <label for="description" class="col-form-label">Profieltekst:</label>
                    <textarea class="form-control bg-light" maxlength="300" rows="5" id="description" name="description" v-model="profile.description"></textarea>
                    <small>Nog {{300 - profile.description.length}} karakters over.</small>
                    <div class="text-right mt-3">
                        <loader v-if="isLoading"></loader>
                        <button v-else type="button" class="btn btn-outline-azure" @click="saveDescription" :disabled="isLoading">Tekst Opslaan</button>
                    </div> 
                </div>
                <hr>
                <label class="col-form-label" for="police-unit">Eenheid Politie</label>
                <select class="form-control bg-light" v-model="user.policeUnitId" @change="savePoliceUnit(user.policeUnitId)" name="police-unit" id="police-unit" :disabled="isLoading"> 
                    <option :value="u.id" v-for="u in $store.getters.policeUnits" :key="u.id" >{{u.name}}</option>
                </select>   
            </div>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader'
export default {
    props: ['user'],
    components: {
        Loader
    },
    data() {
        return {
            isLoading: false
        }
    },
    mounted() {
        this.$store.dispatch('GET_POLICEUNITS');
    },
    methods: {
        saveDescription() {
            this.isLoading = true;
            this.$http.post("api/User/SaveProfileDescription", JSON.stringify(this.profile.description)).then((res) => {
                this.profile.description = res.data;
                this.isLoading = false;
            }).catch(() => {
                this.isLoading = false;
            });
        },
        savePoliceUnit(id) {
            this.isLoading = true;
            this.$http.post('api/policeunits/' + id).then((res) => {
                this.isLoading = false;
                this.$refs.toastr.s("Eenheid Politie is aangepast.");
                let user = Object.assign({}, this.$store.getters.user);
                user.policeUnitId = id;
                this.$store.commit("SET_USER", user);
                this.$emit('editPoliceUnit', id);
            }).catch(() => {
                this.isLoading = false;
                this.$refs.toastr.e("Aanpassen eenheid Politie is mislukt.");
            })
        }
    },
    computed: {
        profile() {
            if(this.user)
            {
                if(this.user.professionalProfile.description == null)
                {
                    this.user.professionalProfile.description = '';
                }
                return this.user.professionalProfile;
            }
            return { description: '' };
        },
        fullName() {
            return this.profile.firstName + ' ' + this.profile.lastName;
        },
        profileImage() {
            if(this.profile)
            {
                const image = this.profile.profileImage;
                if(image)
                    return 'data:' + image.fileContentType + ";base64," + image.file;
            }
            return null;
        }
    }
}
</script>

<style scoped>
.img-profile {
    width: 75%;
}
</style>
